// extracted by mini-css-extract-plugin
export default {"viewport":"YMDvI1aV3FR1iFXOjlBO","tutorial":"sJ6qFjuePIJomuYjiCGR"};